module.exports = __webpack_public_path__ + "img/almenu_gomb_kutatasok_jelentes_aktiv.9e0a1e55.png";